import React, { useEffect, useRef } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import eth from "./images/eth.png";
import "flowbite";
import Description from "./Description";
import Pricing from "./Pricing";
import FAQ from "./FAQ";
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from "react-icons/md";
const Sliding = () => {
  const myRef = useRef(null);

  const handleClick = () => {
    myRef.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    for (let index = 0; index != 1000; index++) {
      setTimeout(() => {}, 2000);
    }
  }, []);
  return (
    <div className="">
      <div
        id="animation-carousel"
        className=" w-full bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52]"
        data-carousel="static"
      >
        {/* <!-- Carousel wrapper --> */}
        <div className="relative lg:h-screen h-[950px] overflow-hidden rounded-lg ">
          {/* <!-- Item 3 --> */}
          <div className="hidden ease-in-out duration-500" data-carousel-item>
            <div className="lg:flex gap-20 md:px-28 px-4 h-screen lg:mt-0 mt-20">
              <div className=" w-full my-auto">
                <h1 className="text-4xl md:text-6xl font-bold  text-white">
                Your Web3 Life Locker…for gifting digital leave-behinds after you’re long gone
                </h1>

                <h1 className="text-[#9EA0A1] text-[18px] py-6">
                  Clowds.io is an encrypted locker for your digital belongings,
                  stored on the blockchain and accessible only by those you
                  choose— kept secret and locked until after you’re gone…
                </h1>

                <button
                  onClick={handleClick}
                  className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10 "
                >
                  <h1>Sign Up</h1>
                </button>
              </div>
              <div className=" w-full my-auto ">
                <img
                  src={eth}
                  className="w-full h-full rounded-2xl lg:mt-0 mt-20"
                />
              </div>
            </div>
          </div>
          {/* <!-- Item 1 --> */}
          <div className="hidden ease-in-out duration-500" data-carousel-item>
            <div className="lg:flex gap-20 md:px-28 px-4 h-screen lg:mt-0 mt-20">
              <div className=" w-full my-auto">
                <h1 className="text-4xl md:text-6xl font-bold  text-white">
                  Wills and Testaments
                </h1>

                <h1 className="text-[#9EA0A1] text-[18px] py-6">
                  for parents, family members and next of kin to ensure
                  beneficiaries have a central and secure storage locker for
                  these important documents— with the privacy of keeping it
                  concealed until you’re gone.
                </h1>

                <button
                  onClick={handleClick}
                  className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10 "
                >
                  <h1>Sign Up</h1>
                </button>
              </div>
              <div className=" w-full my-auto ">
                <img
                  src={eth}
                  className="w-full h-full rounded-2xl lg:mt-0 mt-20"
                />
              </div>
            </div>
          </div>
          {/* <!-- Item 2 --> */}
          <div className="hidden ease-in-out duration-500" data-carousel-item>
            <div className="lg:flex gap-20 md:px-28 px-4 h-screen lg:mt-0 mt-20">
              <div className=" w-full my-auto">
                <h1 className="text-4xl md:text-6xl  text-white font-bold">
                  Records and Accounts
                </h1>

                <h1 className="text-[#9EA0A1] text-[18px] py-6">
                  a single location (as backup) for important information,
                  records and account info for easy retrieval from family
                  members. Ensure they always have access to this vital
                  information— encrypted and protected.
                </h1>
                <button
                  onClick={handleClick}
                  className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10 "
                >
                  <h1>Sign Up</h1>
                </button>
              </div>
              <div className=" w-full my-auto ">
                <img
                  src={eth}
                  className="w-full h-full rounded-2xl lg:mt-0 mt-20"
                />
              </div>
            </div>
          </div>

          {/* <!-- Item 4 --> */}
          <div className="hidden ease-in-out duration-500" data-carousel-item>
            <div className="lg:flex gap-20 md:px-28 px-4 h-screen lg:mt-0 mt-20">
              <div className=" w-full my-auto">
                <h1 className="text-4xl md:text-6xl  text-white font-bold">
                  Parting words
                </h1>

                <h1 className="text-[#9EA0A1] text-[18px] py-6">
                  Say the things you always wanted to say but may have been too
                  awkward to share. Loved ones and family…an ex, estranged
                  family member, or arch nemesis? Leave your final goodbyes
                  behind, inaccessible until after you pass.
                </h1>
                <button
                  onClick={handleClick}
                  className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10 "
                >
                  <h1>Sign Up</h1>
                </button>
              </div>
              <div className=" w-full my-auto ">
                <img
                  src={eth}
                  className="w-full h-full rounded-2xl lg:mt-0 mt-20"
                />
              </div>
            </div>
          </div>
          {/* <!-- Item 5 --> */}
          <div className="hidden ease-in-out duration-500" data-carousel-item>
            <div className="lg:flex gap-20 md:px-28 px-4 h-screen lg:mt-0 mt-20">
              <div className=" w-full my-auto">
                <h1 className="text-4xl md:text-6xl  text-white font-bold">
                  Secrets and Surprises
                </h1>

                <h1 className="text-[#9EA0A1] text-[18px] py-6">
                  Create fun boxes where anything goes to leave a lasting
                  impression for the ones you want.
                </h1>
                <button
                  onClick={handleClick}
                  className="bg-gradient-to-r rounded-full  from-[#2C55B9] to-[#8B53E8]   text-white font-bold py-2 px-10 "
                >
                  <h1>Sign Up</h1>
                </button>
              </div>
              <div className=" w-full my-auto ">
                <img
                  src={eth}
                  className="w-full h-full rounded-2xl lg:mt-0 mt-20"
                />
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Slider controls --> */}
        <button
          type="button"
          className="absolute text-[#fff] top-20 cursor-default left-0 z-30 flex items-center justify-center h-full px-4 group focus:outline-none"
        >
          <MdOutlineNavigateBefore
            data-carousel-prev
            className="inline-flex cursor-pointer items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-[#8B53E8]  group-focus:ring-4 group-focus:ring-white group-focus:outline-none"
          />
        </button>

        <button
          type="button"
          className="absolute text-[#fff] top-20 right-0 z-40 flex items-center justify-center h-full px-4 cursor-default group focus:outline-none"
        >
          <MdOutlineNavigateNext
            data-carousel-next
            className="inline-flex cursor-pointer items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 bg-[#8B53E8]  group-focus:ring-4 group-focus:ring-white group-focus:outline-none"
          />
        </button>
        <img
          src="https://themegenix.net/wp/nerko/wp-content/uploads/2022/12/divider-01.svg"
          className="mx-auto lg:py-1 py-10"
        />
      </div>
      <Description />
      <div id="myComponent" ref={myRef}>
        <Pricing />
      </div>
      <FAQ />
    </div>
  );
};

export default Sliding;
